import { httpservice } from '../services';
import { constants } from '../constant/constant';

const sendSMS = (smsData) => httpservice()
  .post(constants.API.SEND_SMS, smsData)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export default sendSMS;
